<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <clientsidebar></clientsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div v-if="mycertificates!==null">

              <div class="row mt-2">
                <div class="col-sm-12 text-right">
                  <button class="btn btn-secondary btn-short" @click="doAdd">
                    Add
                  </button>
                </div>
              </div>

              <div class="row mt-2 border-bot" v-for="cert in mycertificates" v-show="mycertificates.length>0">
                <div class="col-6">
                  <a v-bind:href="cert.FullLink" target="_blank">{{cert.CertificateName}}</a>
                </div>
                <div class="col-6">
                  <button class="btn-transparent" @click="doRemove(cert.CertificateID)"><font-awesome-icon icon="times"></font-awesome-icon></button>
                </div>
              </div>
              <div class="row mt-2" v-show="mycertificates.length===0">
                <div class="col-12">
                  You do not currently have any certificates
                </div>
              </div>

            </div>
            <div v-if="noaccess===true" id="your_account_does_not_have_access_to_certificates">
              Your account does not have access to Certificates. Please contact SIMmersion to gain access to this area of Admin Center.
            </div>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>

  </div>
</template>

<style scoped>
   .border-bot {
      border-bottom:1px dotted #666;
   }
</style>

<script>
  import "core-js/stable";
  import "regenerator-runtime/runtime";
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"

  export default {
    name: 'Certificates',
    components:{acheader,acfooter,clientsidebar},
    data() {
      return {
        mycertificates:null,
        noaccess:false
      }
    },
    methods: {
      doAdd() {
        this.$router.push("/client/"+this.$route.params.id+"/certificates/add");
      },
      doRemove(certID) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this certificate?  This action cannot be undone!', {
          title: 'Confirm Deletion',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
                {
                  Operation: "Certificate",
                  Function: "Delete",
                  Fields: {
                    CertificateID: certID
                  }
                }
            ]).then(r=>{
              this.popDialog(0,"Certificate Deleted");
              this.render();
            })
          }
        });
      },
      render() {
        if (this.sdata.ispro || this.sdata.isemployee) {
          this.apiCommand([
              {
                Operation: "Certificate",
                Function: "GetCertificates",
                Fields: { }
              }
          ]).then(r=>{
            var cr=JSON.parse(r.CommandResult);
            var certs=JSON.parse(cr.returnObjects[0].returnObject);
            for(var c of certs) {
              c.FullLink=this.$hostname+"/Streamable.svc/GetBlankCertificate?CertificateID="+c.CertificateID;
            }

            this.mycertificates=certs;
          });
        }
        else {
          this.noaccess=true;
        }
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapClient(this.$route.params.id);
        this.render();
      });
    }
  }
</script>
